import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-optionalFunction",
  "use": "icon-optionalFunction-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-optionalFunction\"><defs><style type=\"text/css\"></style></defs><path d=\"M256 512h83.2v172.8H256V512z m428.8 0H768v172.8h-83.2V512z\" p-id=\"7489\" /><path d=\"M896 256h-83.2V83.2c0-44.8-38.4-83.2-83.2-83.2H300.8c-51.2 0-89.6 38.4-89.6 83.2V256H128C57.6 256 0 313.6 0 384v172.8h172.8v-128h256v128h172.8v-128h256v128H1024V384c0-70.4-57.6-128-128-128zM339.2 128h339.2v128H339.2V128z m512 640h-256v-128H428.8v128h-256v-128H0v256c0 70.4 57.6 128 128 128h768c70.4 0 128-57.6 128-128v-256h-172.8v128z\" p-id=\"7490\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/optionalFunction.svg
// module id = +5Bi
// module chunks = 81